import { handleActions } from 'redux-actions';

const initialState = {
    data: [],
    links: {},
    meta: {},
    page: 1,
    limit: 10,
    sort: '',
    fetching: true,
    error: false,
}


export default handleActions({

    FETCH_PAYMENT_METHODS: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: false,
        }
    },

    FETCH_PAYMENT_METHODS_SUCCESS: (state, action) => {
        return {
            ...state,
            data: action.paymentMethods.data,
            links: action.paymentMethods.links,
            meta: action.paymentMethods.meta,
            fetching: false,
        }
    },

    FETCH_PAYMENT_METHODS_FAIL: (state, action) => {
        return {
            ...state,
            fetching: false,
            error: true
        }
    },

}, initialState)
